var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "hide-footer": "", title: _vm.title, size: "lg", centered: "" },
      on: { ok: _vm.test },
      model: {
        value: _vm.display,
        callback: function($$v) {
          _vm.display = $$v
        },
        expression: "display"
      }
    },
    [
      _c(
        "div",
        _vm._l(_vm.notes.ReleaseNotes, function(releasenote) {
          return _c("div", { key: releasenote.Version }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("version")) +
                " " +
                _vm._s(releasenote.Version) +
                " - " +
                _vm._s(_vm.time(releasenote.Date)) +
                "\n      "
            ),
            _c(
              "ul",
              _vm._l(releasenote.Notes, function(note) {
                return _c("li", { key: note }, [
                  _vm._v("\n          " + _vm._s(note) + "\n        ")
                ])
              }),
              0
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d9bfa90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d9bfa90","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/About.vue
// module id = 775
// module chunks = 0